(() => {
    const initCarousels = (root = document) => {
      const carousels = root.querySelectorAll('.js-logo-list-carousel');
  
      for (const carousel of carousels) {
        if (carousel._swiperInstance) continue;
  
        const showPagination = carousel.dataset.showPagination === 'true';
        console.log(showPagination);
        const paginationElement = carousel.querySelector('.swiper-pagination');
  
        carousel._swiperInstance = new Swiper(carousel, {
          loop: true,
          slidesPerView: 2,
          spaceBetween: 48,
          speed: 4000,
          autoplay: { delay: 0 },
          freeMode: true,
          breakpoints: {
            500:  { slidesPerView: 2.5, spaceBetween: 48 },
            768:  { slidesPerView: 3,   spaceBetween: 48 },
            1024: { slidesPerView: 3.5, spaceBetween: 96 },
            1200: { slidesPerView: 4,   spaceBetween: 96 },
            1600: { slidesPerView: 4.5, spaceBetween: 96 },
            1920: { slidesPerView: 5,   spaceBetween: 96 },
          },
          observer: true,
          observeParents: true,
          pagination: showPagination && paginationElement
            ? { el: paginationElement, clickable: true }
            : false,
  
          on: {
            resize: (swiper) => swiper.update(),
          }
        });
      }
    };
  
    document.addEventListener('DOMContentLoaded', () => initCarousels());
    document.addEventListener('shopify:section:load', (e) => initCarousels(e.target));
})();